import { useTemplatePlacementOptional } from '@/contexts/template-placement-context'
import {
  type UsePlacementCanvasBridgeArgs,
  usePlacementCanvasBridge,
} from '@/hooks/use-placement-canvas-bridge'

type TemplatePlacementCanvasBridgeProps = Omit<
  UsePlacementCanvasBridgeArgs,
  'placement' | 'isBlockedByTextChain' | 'acceptsShapeDrops'
>

/**
 * Template-side counterpart of `ClikArtPlacementCanvasBridge`. A template is placed as new
 * elements on top of the spread, never into a shape, so no shape is ever a drop target: the drop
 * is never refused for sitting on a linked text frame, and never fills what is under it.
 */
export function TemplatePlacementCanvasBridge(props: TemplatePlacementCanvasBridgeProps) {
  usePlacementCanvasBridge({
    ...props,
    placement: useTemplatePlacementOptional(),
    isBlockedByTextChain: () => false,
    acceptsShapeDrops: false,
  })

  return null
}
